/** @format */

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSignCircledCheck
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { ProductReviewsPipesModule } from '../pipes/product-reviews-pipes.module';
import { ReviewBadgesComponentModule } from '../review-badges/review-badges.module';
import { ReviewFeaturesComponentModule } from '../review-features/review-features.module';
import { ReviewMediaComponentModule } from '../review-media/review-media.module';
import { ReviewSectionComponent } from './review-section.component';
import { ReviewSliderComponentModule } from '../review-slider/review-slider.module';
import { ReviewStarsComponentModule } from '../review-stars/review-stars.module';
import { ReviewThumbnailsComponentModule } from '../review-thumbnails/review-thumbnails.module';

@NgModule({
	imports: [
		CommonModule,
		HmfButtonComponent,
		HomefieldIconLibraryModule,
		ProductReviewsPipesModule,
		ReviewBadgesComponentModule,
		ReviewFeaturesComponentModule,
		ReviewMediaComponentModule,
		ReviewSliderComponentModule,
		ReviewStarsComponentModule,
		ReviewThumbnailsComponentModule
	],
	declarations: [ReviewSectionComponent],
	exports: [ReviewSectionComponent]
})
export class ReviewSectionModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconSignCircledCheck]);
	}
}
